import { render, staticRenderFns } from "./urgenciaEvolucion.vue?vue&type=template&id=8a3bc61c&scoped=true"
import script from "./urgenciaEvolucion.vue?vue&type=script&lang=js"
export * from "./urgenciaEvolucion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a3bc61c",
  null
  
)

export default component.exports